import { Button } from '@/components/Button'
import { Form } from '@/components/Form'
import { Input } from '@/components/Input'
import { CommonError } from '@/shared/Auth/components/CommonError'
import { Row } from '@/shared/Auth/components/Row'
import { Title } from '@/shared/Auth/components/Title'
import { FC } from 'react'
import styles from './PasswordResetRequest.module.scss'

interface PasswordResetRequest {
  className?: string
  isLoading?: boolean
  email: string
  errors: {
    common?: string
    email?: string
  }
  changeEmail: (email: string, name: string) => void
  resetPassword: () => void
}
export const PasswordResetRequest: FC<PasswordResetRequest> = ({
  className,
  isLoading = false,
  email,
  changeEmail,
  errors,
  resetPassword,
}) => {
  return (
    <Form
      className={className}
      onSubmit={resetPassword}
      testId="passwordResetRequestForm"
    >
      <Title title="Восстановление пароля" />
      <Row>
        <CommonError errors={errors} />
      </Row>
      <Row isAdditional>
        <Input
          value={email}
          onChange={changeEmail}
          type="email"
          name="email"
          error={errors.email}
          placeholder="E-mail"
        />
      </Row>
      <Button
        className={styles.button}
        isLoading={isLoading}
        type="submit"
        name="Отправить запрос"
        testId="passwordResetRequestButton"
      />
    </Form>
  )
}
